import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getActiveNews, getNewsByGuid } from '../../api/newsService';
import SocialShare from '../../components/SocialShare/SocialShare';
import QuickMenu from '../../components/QuickMenu/QuickMenu';

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

const DEFAULT_IMAGE = '/assets/images/example-post.jpg';

function NewsDetail() {
  const { urlTag } = useParams();
  const navigate = useNavigate();
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const fetchNewsDetails = async () => {
      if (!urlTag) {
        navigate('/haberler');
        return;
      }

      try {
        setLoading(true);
        setError(null);
        
        // Önce urlTag'e sahip haberi bulmak için tüm aktif haberleri çekelim
        const activeNewsResponse = await getActiveNews(1, 100);
        if (!activeNewsResponse.isSuccess) {
          throw new Error('Haberler yüklenemedi');
        }

        // urlTag'e sahip haberi bulalım
        const targetNews = activeNewsResponse.data.items.find(news => news.urlTag === urlTag);
        if (!targetNews) {
          throw new Error('Haber bulunamadı');
        }

        // Şimdi guid ile haber detaylarını çekelim
        const response = await getNewsByGuid(targetNews.guid);
        if (response.isSuccess && response.data) {
          setNews(response.data);
          setError(null);
        } else {
          throw new Error(response.resultMessage || 'Haber detayları yüklenemedi');
        }
      } catch (error) {
        console.error('Error in fetchNewsDetails:', error);
        setError(error.message || 'Haber yüklenirken bir hata oluştu');
      } finally {
        setLoading(false);
      }
    };

    fetchNewsDetails();
  }, [urlTag, navigate]);

  useEffect(() => {
    let redirectTimer;
    if (error && !loading) {
      redirectTimer = setTimeout(() => {
        navigate('/haberler');
      }, 3000);
    }
    return () => redirectTimer && clearTimeout(redirectTimer);
  }, [error, loading, navigate]);

  const handleImageError = (e) => {
    console.log('Image failed to load, using default image');
    e.target.src = DEFAULT_IMAGE;
  };

  if (loading) {
    return (
      <div className="news-detail">
        <div className="container-fluid px-5 py-5">
          <div className="loading">Yükleniyor...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="news-detail">
        <div className="container-fluid px-5 py-5 ">
          <div className="alert alert-warning" role="alert">
            {error}
          </div>
        </div>
      </div>
    );
  }

  if (!news) {
    return null;
  }

  return (
    <div className="news-detail">
      <div className="container-fluid lg-px-5 lg-py-5"> 
        <div className="row">
          <QuickMenu />
          <div className="col-md-10">
            <div className="news-detail-content-wrapper">
              <div className="news-detail-image">
                <img 
                  src={news.pictureUrl || DEFAULT_IMAGE} 
                  alt={news.header} 
                  className="img-fluid"
                  onClick={() => setIsOpen(true)}
                  onError={handleImageError}
                />
                <Lightbox
                  open={isOpen}
                  close={() => setIsOpen(false)}
                  slides={[
                    { src: news.pictureUrl || DEFAULT_IMAGE }
                  ]}
                />
              </div>
              
              <div className="news-detail-text">
                <h1 className="news-detail-title">{news.header}</h1>
                <div className="news-detail-meta">
                  <span className="date">{new Date(news.newsDate).toLocaleDateString('tr-TR')}</span>
                </div>
                <div className="mini-description alert alert-info">
                  <p className="mb-0">{news.shortDetail}</p>
                </div>
                
                <div className="news-detail-content">
                  <p className="lead">{news.detail}</p>
                </div>
              </div>
            </div>
            
            <div className="mt-4">
              <SocialShare />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewsDetail;
